module.exports = __webpack_public_path__ + "static/media/img2.0905e9a9.png";